import React, { useEffect, useState } from 'react';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from '../componentes/Menu';
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CarAlumnoDatos from '../element/CarAlumnoDatos';
import CarToefl from '../element/CarToefl';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
// import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
import loadMenu from '../js/main';
import Footer from '../componentes/Footer';

import '../css/styleAdmin.css';
// import { data } from 'jquery';

const AlumnosToefl = () => {

    const history = useHistory();

    const [carnet, setCarnet] = useState({});
    const [toefl, setToefl] = useState({});
    const [aprobado, setAprobado] = useState();
    const [fechaExamen, setFechaExamen] = useState();
    const [tipoToefl, setTipoToefl] = useState();
    const [alumno, setAlumno] = useState({});
    const [solvencia, setSolvencia] = useState();
    const [cargando, setCargando] = useState(false);


    // const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    if (!datos) {
        history.push("/");
    }

    datos = JSON.parse(datos);

    if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
        if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1  && dataFinanzas.indexOf(datos.carnet.trim()) === -1) {
          history.push("/");
        }
      }  

    let carnetSet = (e) => {
        setCarnet(e.target.value)
    }

    let onSutmit = (e) => {
        e.preventDefault();
        localStorage.setItem('currentCarnet', carnet);
        setCargando(true);
        let toeflAlumno = GetFetch.toefl(carnet, datos.token);
        toeflAlumno.then((dataToefl) => {
            if (!dataToefl.length <= 0) {
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                setToefl(dataToefl);                
                AlumnoDatos();               
            }else{
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                setToefl(0);
                AlumnoDatos();
                if(localStorage.getItem('solvencia')){
                    setSolvencia('INSOLVENTE')
                    setTimeout(() => {
                      localStorage.removeItem('solvencia')
                    }, 5000);
                    setAprobado(null)
                    setFechaExamen(null)
                    setTipoToefl(null);
                }else{
                    setSolvencia(null)
                    setAprobado(null)
                    setFechaExamen(null)
                    setTipoToefl(null);
                }
            }
            setCargando(false);
        }).catch(() => setCargando(false));
    }

    let AlumnoDatos = () => {
        let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
        datosAlum.then((data) => {
            if (data[0]) {
                setAlumno(data[0]);                
            }
        });
    }

    useEffect(() => {
        loadMenu();
        let currentCarnet = localStorage.getItem('currentCarnet');
        if (currentCarnet) {
            setCarnet(currentCarnet);
        }else{
            setCarnet('');
        }
        document.getElementById('textCarnet').focus();
    }, []);

    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto
                        foto={datos.carnet}
                        alt="Foto alumno"
                        tamanio="rounded" />

                    <HeaderMenu
                        carnet={datos.carnet}
                        nombre={datos.nombre}
                        perfil={datos.perfil}
                        carrera={datos.carrera}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">TOEFL por alumno</h2>

                <div className="card mb-4">
                    <div className="card-body">
                        <form id='formUP' onSubmit={onSutmit}>
                            <div className="form-group">
                                <label htmlFor="textCarnet">Carnet del alumno</label>
                                <input id="textCarnet" type="text" placeholder="Carnet" className="form-control" onChange={carnetSet} value={carnet} />
                            </div>
                            <button type="submit" className="btn btn-primary">
                                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                                Buscar
                            </button>
                        </form>
                    </div>
                </div>

                <CarAlumnoDatos
                    alumno={alumno}
                />

                {aprobado ? (
                    <div className="esen-stat-grid">
                        <div className="esen-stat esen-stat--hero">
                            <div>
                                <div className="esen-stat-value">Aprobado</div>
                                <div className="esen-stat-label">
                                    {tipoToefl} · Examen realizado el {fechaExamen}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                {cargando ? (
                    <SkeletonCard rows={4} />
                ) : toefl.length > 0 ? (
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Componente</th>
                                            <th scope="col" className="text-right">Puntaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {toefl.map((element) => {
                                            if (!aprobado) {
                                              setAprobado('APROBADO')
                                              let fecha = new Date(element.toefl_fecha);
                                              let formatFecha = fecha.toLocaleString().split(',');
                                              setFechaExamen(formatFecha[0])
                                              setTipoToefl(element.tipotoefl)
                                            }
                                            return (
                                              <CarToefl
                                                datos={element}
                                                key={element.estructura}
                                              />
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                ) : solvencia ? (
                    <div className="alert alert-danger" role="alert">
                        <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                        <b>Alumno insolvente.</b> Debe regularizar sus pagos para poder consultar su resultado de TOEFL.
                    </div>
                ) : (
                    <EmptyState icon="fa-search" title="Busca un alumno por carnet">
                        Ingresa el carnet del alumno y presiona Buscar para consultar su resultado de TOEFL.
                    </EmptyState>
                )}
            </div>
        </div>
    )

}

export default AlumnosToefl;